import { MS_PER_DAY } from './utc-day';

const MS_PER_HOUR = 60 * 60 * 1000;
const MS_PER_MINUTE = 60 * 1000;

export const formatTimeOfDay = (
  msSinceMidnight: number | null,
): string | null => {
  if (msSinceMidnight === null) {
    return null;
  }
  if (msSinceMidnight < 0 || msSinceMidnight >= MS_PER_DAY) {
    return null;
  }
  const hours = Math.floor(msSinceMidnight / MS_PER_HOUR);
  const minutes = Math.floor((msSinceMidnight % MS_PER_HOUR) / MS_PER_MINUTE);
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};
